var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.options.length
        ? _c(
            "div",
            {
              staticClass: "availability-price-selector",
              attrs: { role: "group", "aria-label": "Price type" },
            },
            _vm._l(_vm.options, function (option) {
              return _c(
                "button",
                {
                  key: option.value,
                  staticClass: "availability-price-selector__option",
                  class: {
                    "availability-price-selector__option--active":
                      _vm.selectedPriceType === option.value,
                  },
                  attrs: {
                    type: "button",
                    "aria-pressed": _vm.selectedPriceType === option.value,
                  },
                  on: {
                    click: function ($event) {
                      _vm.selectedPriceType = option.value
                    },
                  },
                },
                [_vm._v("\n            " + _vm._s(option.label) + "\n        ")]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default", null, { priceType: _vm.selectedPriceType }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }